import React, {Component, Fragment} from 'react';

import Card from './Card.js';


export default class ContractCards extends Component {

	constructor(props) {
        super(props);
    }

    render() {

		return (
			<Fragment>
				<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
					<Card title="클래스" value={this.props.data.yearClass} total={this.props.data.totalClass}/>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
					<Card title="앱 지수" value={this.props.data.app_score} rate={34} isRate={false}/>
				</div>
                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <Card title="콘텐츠 지수" value={this.props.data.content_score} rate={-17} isRate={false}/>
                </div>
			</Fragment>
		)

	}

}

